import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DxPopupModule, DxSelectBoxModule } from 'devextreme-angular';
import { EnvironmentService } from '../../_services/environment.service';

@Component({
  selector: 'app-modalCA',
  templateUrl: './modalCA.component.html',
  styleUrls: ['./modalCA.component.scss']
})
export class ModalCAComponent implements OnInit {

  @Input() isVisible: boolean = false;
  @Input() decodedPayload: any;
  @Output() valorSeleccionadoChange = new EventEmitter<any>();

  datosEmpresa: any = [];
  selectBoxData: any = [];
  valorEmpresaSeleccionado: any;
  searchModeOption = 'contains';
  searchExprOption: any = 'RazonSocialEmpresa';
  searchTimeoutOption = 200;
  minSearchLengthOption = 1;
  showDataBeforeSearchOption = true ;

  constructor(
    private http: HttpClient,
    private envService: EnvironmentService,
    ) {
      this.isVisible = false;
      this.datosEmpresa = [];
    }

  async ngOnInit() {

    const urlConsultaEmpresasCA = `${this.envService.ConsultaEmpresasCA}`;

    //const body = { TipoId_ContactoAdm: this.decodedPayload.TipoIdentificacionContactoAdministrativo, NumeroId_ContactoAdm: '1073513709' };
    //const body = { TipoId_ContactoAdm: this.decodedPayload.TipoIdentificacionContactoAdministrativo, NumeroId_ContactoAdm: '52523186' };
    const body = { TipoId_ContactoAdm: this.decodedPayload.TipoIdentificacionContactoAdministrativo, NumeroId_ContactoAdm: this.decodedPayload.NumeroIdentificacionContactoAdmin };

    const headers = new HttpHeaders({
      'Authorization': `${this.envService.ConsultaEmpresasCA_Authorization}`,
      'Ocp-Apim-Subscription-Key': `${this.envService.ConsultaEmpresasCA_OcpApim}`
    });


    await this.http.post(urlConsultaEmpresasCA, body, { headers: headers }).subscribe( (data:any) => {

      this.isVisible = false;
      if (Array.isArray(data.Empresas)) {
        this.datosEmpresa = data.Empresas
        this.isVisible = (data.Empresas.length > 1);
      } else if (typeof data.Empresas === 'object') {
        this.datosEmpresa.push(data.Empresas);
        this.valorSeleccionado = data.Empresas.NumeroId_Empresa;
        this.valorSeleccionadoChange.emit(this.valorSeleccionado);
        
      } else {
        this.datosEmpresa =[];
      }
      this.selectBoxData = this.datosEmpresa;
      console.log(this.selectBoxData);
      return  this.datosEmpresa;

    });

  }

  valorSeleccionado: any; // Tipo según lo que seleccione el usuario
  onValueChanged(e) {
      this.valorSeleccionado = e.value;
      console.log(this.valorSeleccionado);
      this.valorSeleccionadoChange.emit(this.valorSeleccionado);
  }

}
